<template>
  <div class="max-w-3xl mx-auto text-center">
    <h1 class="text-2xl font-bold">Welcome to Humaniz! Could you tell us about yourself?</h1>
    <p class="text-lg mb-4">First, we'll need some basic information about you.</p>
    <FormKit type="form" @submit="$emit('next')" class="mt-8" v-model="formData" :actions="false">
      <FormKit
        type="text"
        name="firstName"
        label="First Name"
        validation="required"
        placeholder="Enter your first name"
      />
      <FormKit type="text" name="lastName" label="Last Name" validation="required" placeholder="Enter your last name" />
      <FormKit
        type="text"
        name="phoneNumber"
        label="Phone"
        validation="required"
        placeholder="Enter your phone number"
      />
      <FormKit
        type="select"
        name="role"
        label="Your Role"
        :options="teamRoles"
        placeholder="Select your role"
        validation="required"
      />
      <FormKit type="submit" label="Continue" class="btn btn-primary" />
    </FormKit>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    teamRoles() {
      return ['Team Leader', 'Broker Owner', 'Sales Manager', 'Recruiter', 'Agent', 'Other'];
    },
    formData: {
      set(newData) {
        this.$store.commit('onboarding/setProfile', newData);
      },
      get() {
        return this.profile;
      },
    },
    ...mapState('onboarding', {
      profile: state => state.onboarding.profile,
    }),
  },
};
</script>
